module["exports"] = [
  "######"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_TW/address/postcode.js
// module id = 2003
// module chunks = 0